// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var schemeIsSymbol = {
    reflectSymbol: function () {
        return "scheme";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var messageIsSymbol = {
    reflectSymbol: function () {
        return "message";
    }
};
var additionalInfoIsSymbol = {
    reflectSymbol: function () {
        return "additionalInfo";
    }
};
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString))(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)(schemeIsSymbol)())(nameIsSymbol)())(messageIsSymbol)())(additionalInfoIsSymbol)())());
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString))(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(schemeIsSymbol)()())(nameIsSymbol)()())(messageIsSymbol)()())(additionalInfoIsSymbol)()())());
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither);
var when = /* #__PURE__ */ Control_Applicative.when(Data_Either.applicativeEither);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var NQErrorScheme = function (x) {
    return x;
};
var NQError = function (x) {
    return x;
};
var toNqErrorScheme = function (fsErrorScheme) {
    if (fsErrorScheme instanceof Fusion_Data_FSError.JSSdkScheme) {
        return fsErrorScheme.value0;
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl50) {
        return "Cl-50-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl51) {
        return "Cl-51-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl52) {
        return "Cl-52-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl53) {
        return "Cl-53-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl54) {
        return "Cl-54-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl55) {
        return "Cl-55-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl56) {
        return "Cl-56-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl57) {
        return "Cl-57-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl58) {
        return "Cl-58-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl59) {
        return "Cl-59-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl60) {
        return "Cl-60-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl61) {
        return "Cl-61-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl62) {
        return "Cl-62-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl63) {
        return "Cl-63-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl64) {
        return "Cl-64-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl65) {
        return "Cl-65-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl66) {
        return "Cl-66-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl67) {
        return "Cl-67-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl68) {
        return "Cl-68-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl69) {
        return "Cl-69-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl70) {
        return "Cl-70-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl71) {
        return "Cl-71-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl72) {
        return "Cl-72-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl73) {
        return "Cl-73-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl74) {
        return "Cl-74-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl75) {
        return "Cl-75-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl76) {
        return "Cl-76-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl77) {
        return "Cl-77-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl78) {
        return "Cl-77-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.Cl99) {
        return "Cl-99-130";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.DnCn51) {
        return "Dn-Cn-51-164";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.DnCn52) {
        return "Dn-Cn-52-165";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.UpCn51) {
        return "Dn-Cn-51-166";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.UpCn52) {
        return "Dn-Cn-52-167";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnCn50) {
        return "Pn-Cn-50-168";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnCn51) {
        return "Pn-Cn-51-169";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnCn52) {
        return "Pn-Cn-52-170";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnCn53) {
        return "Pn-Cn-53-170";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnCn54) {
        return "Pn-Cn-54-170";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnCn55) {
        return "Pn-Cn-55-170";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.PnRe50) {
        return "Pn-Re-50-171";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.StCn50) {
        return "St-Cn-50-180";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.StRe50) {
        return "St-Re-50-180";
    };
    if (fsErrorScheme instanceof Fusion_Data_FSError.EnCn50) {
        return "En-Cn-50-180";
    };
    throw new Error("Failed pattern match at Fusion.Foreign.Data.NQError (line 37, column 3 - line 85, column 37): " + [ fsErrorScheme.constructor.name ]);
};
var nqErrorName = "NQError";
var toNQError = function (v) {
    var v1 = toNqErrorScheme(v.scheme);
    var json = encodeJson({
        name: nqErrorName,
        scheme: v1,
        message: v.message,
        additionalInfo: v.additionalInfo
    });
    return json;
};
var fromNQError = function (v) {
    return bind(decodeJson(v))(function (v1) {
        return discard(when(v1.name !== nqErrorName)(throwError(new Data_Argonaut_Decode_Error.AtKey("name", new Data_Argonaut_Decode_Error.UnexpectedValue(Data_Argonaut_Core.fromString(v1.name))))))(function () {
            return pure({
                scheme: new Fusion_Data_FSError.JSSdkScheme(v1.scheme),
                message: v1.message,
                additionalInfo: v1.additionalInfo
            });
        });
    });
};
export {
    fromNQError,
    toNQError
};
